import axios from "axios";
import {useCoreStore} from "@/stores/CoreStore";
import {useAccountStore} from "@/stores/AccountStore";
import {useDesignerStore} from "@/stores/DesignerStore";
import {useToast} from "vue-toastification";
export default class CoreService {
    constructor(pageData) {
        const coreStore = useCoreStore();
        coreStore.pageData = pageData.pageData;

        this.baseUrl = process.env.VUE_APP_API_URL
        this.id = pageData.productId

        // Create Axios instance with base URL
        this.axios = axios.create({
            baseURL: this.baseUrl,
        });
        
        // Expose axios instance as 'api' for backward compatibility
        this.api = this.axios;
        coreStore.page = 'pg-' + pageData.page
    }

    /**
     * Initialize an adhoc payment (creates Super Payments checkout session)
     * @param {Object} data - { reference: string, amount: number }
     * @returns {Promise}
     */
    async initAdhocPayment(data) {
        return this.axios.post('/api/adhoc-payment/init', data)
    }

    /**
     * Proceed with adhoc payment after Super Payments submission
     * @param {Object} data - Payment and customer details
     * @returns {Promise}
     */
    async proceedAdhocPayment(token, data) {
        return this.axios.post(`/api/adhoc-payment/proceed/${token}`, data)
    }

    /**
     * Check adhoc transaction status after payment redirect
     * @param {string} token - Transaction token
     * @returns {Promise}
     */
    async checkAdhocTransaction(token) {
        return this.axios.get(`/api/adhoc-payment/confirm/${token}`)
    }

    /**
     * Fetch order details by confirmation token
     * @param {string} token - Order confirmation token
     * @returns {Promise}
     */
    async confirmOrder(token) {
        return this.axios.get(`/api/order/confirm/${token}`)
    }

}
